import React, { Component } from 'react'
import { preFix } from '@/constant/index'
import styles from './index.module.less'
import { handleStyle } from '@/utils/styleUtils/index'

class Block extends Component<any, any> {
  static config = {
    name: 'poizon-block',
  }
  // componentDidMount() {}
  render() {
    const { propsConfig } = this.props
    return (
      <div className={preFix + Block.name}>
        <div className={styles.block} style={handleStyle(propsConfig, ['height'])}></div>
      </div>
    )
  }
}

export default Block
